/*global localStorage */
let _ = require("ES/lib/lodash");
let Balboa = require("ES/services/Balboa");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

let sitelist_cache = null;
// let dataIsDirty = false;

module.exports.init = function(){
  RadioService("Sitelists_get", function(params, callback) {
    // if((sitelist_cache !== null) && !dataIsDirty){
    //   callback(null, sitelist_cache);
    //   return;
    // }
    var signature_key = 'Sitelists_signature_' + _.get(params, ["id"]);
    var signature = localStorage.getItem(signature_key) !== null ? localStorage.getItem(signature_key) : '';
    Balboa.api("/authenticate/getsitelists", {
      signature: signature,
      company: _.get(params, ["id"]),
      clear_cache: _.get(params, ["clear_cache"], false)
    }, function(data){
      sitelist_cache = data.data;
      // dataIsDirty = false;
      callback(null, sitelist_cache);
    }, function(data){
      callback((data && data.message) || "unknown cause");
    });
  }, function() {
    return 1;
  });

  RadioService("clear_Cache", function(params, callback) {

  }, function() {
    return 1;
  });
};



// WEBPACK FOOTER //
// ./src/services/Sitelists.js